import axios from 'axios';

export default {
    methods: {
        async microClienteBuscar(d, ok, err) {
            try {
                let r = await axios.post('cliente/micro-buscar', d);
                ok(r.data)
            } catch (r) {
                err(r)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/micro/clientes.js